import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { fireToastError } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import fetchPriceConfiguration from '../../models/Price/fetchPriceConfiguration'
import { PriceConfigurationActions, PriceGridAction } from '../../reducers/price/actionNames'
import { getUserObjectId } from '../../reducers/userObject/selectors/object'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import requestDataForObject from '../../actions/userObject/profile/requestFetchUserProfile'
import fetchRoomSettings from '../../models/Price/fetchRoomSettings'
import { PriceEditModalActions } from '../../reducers/priceEdit/actionNames'
import { getNewPrices } from '../../reducers/price/selectors/price'
import { isSameDay } from 'date-fns'
import fetchRoomSettingsGlobal from '../../models/Price/fetchRoomSettingsGlobal'
import { getPriceEditModalType } from '../../reducers/priceEdit/selectors'
import { Mixpanel } from '../../utils/Mixpanel'

function* loadConfiguration(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchPriceConfiguration)
    const [{ calendarId, service }, objectId] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.select(getUserObjectId),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          fetchPriceConfiguration,
        ),
      ),
    ])

    if (!objectId || !calendarId) {
      yield Effects.put(requestDataForObject())
      yield Effects.delay(200)
      yield* loadConfiguration(action)
      return
    }

    let priceConfiguration = []

    if (action.priceConfig) {
      priceConfiguration = action.priceConfig
    } else {
      priceConfiguration = yield Effects.call(
        service,
        objectId,
        String(calendarId),
      )
    }

    yield Effects.put({
      configuration: priceConfiguration[0],
      type: PriceConfigurationActions.PriceConfigurationAccepted,
    })
  } catch (e) {
    //console.error(e)
    yield Effects.put({
      type: PriceConfigurationActions.SetConfigurationLoading,
      payload: false,
    })
    yield Effects.put(
      fireToastError(
        i18n.t('error_server_response_2'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }
}

function* mixPanelEventRun(action) {
    yield Mixpanel.track('Local Commission Window Opened', [])
    return
}

function* loadPriceRoomSettings(action) {
  if(action.roomId) {
    try {
      const actionNames = fetchActionsName(ActionNames.FetchPriceRoomSettings)
      const [{ calendarId, service }] = yield Effects.all([
        Effects.take(actionNames.output),
        Effects.put(
          callFetch(
            actionNames.input,
            actionNames.output,
            fetchRoomSettings,
          ),
        ),
      ])

       let roomSettings = yield Effects.call(
          service,
          action.roomId,
          String(calendarId),
        )

     yield Effects.put({type: PriceGridAction.PutRoomSettings, payload: roomSettings})

    } catch (e) {
      //console.error(e)
    }
  }
}

export function* fetchGlobalRoomSettings(action) {
    try {

      //console.log('fetchGlobalRoomSettings')
      const actionNames = fetchActionsName(ActionNames.FetchPriceGlobalRoomSettings)
      const [{ calendarId, service }] = yield Effects.all([
        Effects.take(actionNames.output),
        Effects.put(
          callFetch(
            actionNames.input,
            actionNames.output,
            fetchRoomSettingsGlobal,
          ),
        ),
      ])



       let roomSettings = yield Effects.call(
          service,
          String(calendarId),
        )

     yield Effects.put({type: PriceGridAction.PutRoomSettingsGlobal, payload: roomSettings})

    } catch (e) {
      //console.error(e)
      yield Effects.put({type: PriceGridAction.PutRoomSettingsGlobal, payload: []})
    }
}

const mapPTypeToPriceType = (pType) => {
  if (pType && pType.includes('BedBooking') && !pType.includes('BookingDependent'))
    return 'bedbooking'
  if (pType && (pType.includes('Booking-') || pType.includes('BookingDependent')))
    return 'booking'
  if (pType && pType.includes('Airbnb'))
    return 'airbnb'
  return 'bedbooking'
}

/** Booking: price_change_type '0' = procent, '1' = kwota stała */
function applyDependentPriceChange(parentVal, amount, changeType) {
  if (parentVal == null || parentVal === '' || Number.isNaN(Number(parentVal))) return parentVal
  const p = Number(parentVal)
  const a = Number(amount) || 0
  if (changeType === '0' || changeType === 0) {
    return Math.round(p * (1 + a / 100) * 100) / 100
  }
  return Math.round((p + a) * 100) / 100
}

function mapPricesWithDependentChange(obj, amount, changeType) {
  if (obj == null) return obj
  if (typeof obj === 'number' || (typeof obj === 'string' && obj !== '' && !Number.isNaN(Number(obj)))) {
    return applyDependentPriceChange(obj, amount, changeType)
  }
  if (Array.isArray(obj)) return obj.map(v => mapPricesWithDependentChange(v, amount, changeType))
  if (typeof obj === 'object') {
    const out = {}
    for (const key of Object.keys(obj)) {
      out[key] = mapPricesWithDependentChange(obj[key], amount, changeType)
    }
    return out
  }
  return obj
}

function* fetchData(action) {
  if (action.roomId) {
    if (action.startDate) {
      let data = {}

      const prices = yield Effects.select(getNewPrices)
      const pricesForRoom = prices.find(price => price.id_room === action.roomId)

      //console.log(action.startDate, action.startDate.toISOString(), new Date(action.startDate.getTime() - action.startDate.getTimezoneOffset() * 60 * 1000).toISOString())
      const date= new Date(action.startDate.getTime() - action.startDate.getTimezoneOffset() * 60 * 1000).toISOString().substring(0, 10)
      if (pricesForRoom) {
        const pType = yield Effects.select(getPriceEditModalType)
        const isBookingDependent = pType && pType.startsWith('BookingDependent-')
        const parts = pType ? pType.split('-') : []
        const parentId = isBookingDependent && parts.length >= 2 ? parts[1] : null
        const dependentId = isBookingDependent && parts.length >= 3 ? parts[2] : null

        let pricesForRoomFiltered = pricesForRoom.prices[mapPTypeToPriceType(pType)].find(price => {
          if (isBookingDependent && parentId) return price.external_pricing_id === parentId && (price.price_day_from <= date || isSameDay(price.price_day_from, date)) && (price.price_day_to >= date || isSameDay(price.price_day_to, date))
          if (pType.includes('Booking-') && !isBookingDependent) return price.external_pricing_id === pType.split('-')[1] && (price.price_day_from <= date || isSameDay(price.price_day_from, date)) && (price.price_day_to >= date || isSameDay(price.price_day_to, date))
          if (!pType.includes('Booking-')) return (price.price_day_from <= date || isSameDay(price.price_day_from, date)) && (price.price_day_to >= date || isSameDay(price.price_day_to, date))
          return false
        })

        let restrictionsForRoom = pricesForRoom.restrictions[mapPTypeToPriceType(pType)].find(restriction => {
          if (isBookingDependent && dependentId) return restriction.external_pricing_id === dependentId && (restriction.restriction_day_from <= date || isSameDay(restriction.restriction_day_from, date)) && (restriction.restriction_day_to >= date || isSameDay(restriction.restriction_day_to, date))
          if (pType.includes('Booking-') && !isBookingDependent) return restriction.external_pricing_id === pType.split('-')[1] && (restriction.restriction_day_from <= date || isSameDay(restriction.restriction_day_from, date)) && (restriction.restriction_day_to >= date || isSameDay(restriction.restriction_day_to, date))
          if (!pType.includes('Booking-')) return (restriction.restriction_day_from <= date || isSameDay(restriction.restriction_day_from, date)) && (restriction.restriction_day_to >= date || isSameDay(restriction.restriction_day_to, date))
          return false
        })

        if (isBookingDependent && parentId && dependentId && pricesForRoomFiltered) {
          const bookingObjects = yield Effects.select(state => state.booking && state.booking.bookingObjects)
          const roomSettingsGlobal = yield Effects.select(state => state.price && state.price.roomSettingsGlobal)
          let dependentPlan = null
          if (Array.isArray(bookingObjects)) {
            const allMappings = bookingObjects.reduce((acc, obj) => acc.concat(obj.mappings || []), [])
            const allRooms = bookingObjects.reduce((acc, obj) => acc.concat(obj.rooms || []), [])
            const mapping = allMappings.find(m => (m.bed_booking_rooms || []).includes(String(action.roomId)))
            if (mapping) {
              const room = allRooms.find(r => String(r.id) === String(mapping.booking_id))
              if (room && room.pricing) {
                dependentPlan = room.pricing.find(p => String(p.booking_id) === String(dependentId))
              }
            }
          }
          const roomSettingsForRoom = Array.isArray(roomSettingsGlobal) ? roomSettingsGlobal.find(ro => String(ro.id) === String(action.roomId)) : null
          const savedDep = roomSettingsForRoom?.integrations?.booking?.find(b => String(b.booking_id_pricing) === String(dependentId))
          const amount = savedDep?.price_change_amount !== undefined && savedDep?.price_change_amount !== null
            ? savedDep.price_change_amount
            : (dependentPlan ? (dependentPlan.price_change_amount ?? dependentPlan.price_change ?? 0) : 0)
          const changeType = savedDep?.price_change_type !== undefined && savedDep?.price_change_type !== null
            ? savedDep.price_change_type
            : (dependentPlan ? (dependentPlan.price_change_type ?? '1') : '1')
          const rawPrices = {
            extrabed: pricesForRoomFiltered.extrabed,
            long: pricesForRoomFiltered.long,
            short: pricesForRoomFiltered.short,
            weekend: pricesForRoomFiltered.weekend,
            standard: pricesForRoomFiltered.standard,
            kids: pricesForRoomFiltered.kids || {},
          }
          const computedPrices = mapPricesWithDependentChange(rawPrices, amount, changeType)
          const standardKeys = computedPrices.standard && typeof computedPrices.standard === 'object' && !Array.isArray(computedPrices.standard)
            ? Object.keys(computedPrices.standard).map(Number).filter(k => k >= 1)
            : []
          const roomCapacity = standardKeys.length ? Math.max(2, ...standardKeys) : 2
          const fillMissingPersonKeys = (obj) => {
            if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return obj
            const firstVal = Object.keys(obj).length ? obj[Object.keys(obj).sort((a, b) => Number(a) - Number(b))[0]] : undefined
            if (firstVal === undefined) return obj
            const out = { ...obj }
            for (let k = 1; k <= roomCapacity; k++) {
              if (out[k] == null || out[k] === '') out[k] = firstVal
            }
            return out
          }
          const standard = fillMissingPersonKeys(computedPrices.standard)
          const weekend = fillMissingPersonKeys(computedPrices.weekend)
          let kids = {}
          if (computedPrices.kids && typeof computedPrices.kids === 'object' && !Array.isArray(computedPrices.kids)) {
            kids = computedPrices.kids
          }
          data = {
            prices: {
              extrabed: computedPrices.extrabed,
              long: computedPrices.long,
              short: computedPrices.short,
              weekend,
              standard,
              kids,
            },
          }
        } else if (pricesForRoomFiltered) {

          let kids = []

          if (pricesForRoomFiltered.kids) {
            pricesForRoomFiltered.kids.forEach(kid => {
              kids[kid.kid_id] = kid
            })
          }

          data = {
            prices: {
              extrabed: pricesForRoomFiltered.extrabed,
              long: pricesForRoomFiltered.long,
              short: pricesForRoomFiltered.short,
              weekend: pricesForRoomFiltered.weekend,
              standard: pricesForRoomFiltered.standard,
              kids: kids,
            },
          }
        }

        if (restrictionsForRoom) {
          data = {
            ...data,
            restrictions: {
              restriction_close_at_arrival_days: restrictionsForRoom.restriction_close_at_arrival ? dateToDays(action.startDate) : [],
              restriction_close_at_departure_days: restrictionsForRoom.restriction_close_at_departure ? dateToDays(action.startDate) : [],
              restriction_exact_stay_days: restrictionsForRoom.restriction_exact_stay ? dateToDays(action.startDate) : [],
              restriction_exact_stay_nights: restrictionsForRoom.restriction_exact_stay,
              restriction_max_before_arrival_hours: restrictionsForRoom.restriction_max_before_arrival % 24,
              restriction_max_before_arrival_nights: ~~(restrictionsForRoom.restriction_max_before_arrival / 24),
              restriction_max_before_arrival_days: restrictionsForRoom.restriction_max_before_arrival ? dateToDays(action.startDate) : [],
              restriction_max_stay_nights: restrictionsForRoom.restriction_max_stay,
              restriction_max_stay_days: restrictionsForRoom.restriction_max_stay ? dateToDays(action.startDate) : [],
              restriction_max_stay_thru_nights: restrictionsForRoom.restriction_max_stay_thru,
              restriction_max_stay_thru_days: restrictionsForRoom.restriction_max_stay_thru ? dateToDays(action.startDate) : [],
              restriction_min_before_arrival_hours: restrictionsForRoom.restriction_min_before_arrival % 24,
              restriction_min_before_arrival_nights: ~~(restrictionsForRoom.restriction_min_before_arrival / 24),
              restriction_min_before_arrival_days: restrictionsForRoom.restriction_min_before_arrival ? dateToDays(action.startDate) : [],
              restriction_min_stay_nights: restrictionsForRoom.restriction_min_stay,
              restriction_min_stay_days: restrictionsForRoom.restriction_min_stay ? dateToDays(action.startDate) : [],
              restriction_min_stay_thru_nights: restrictionsForRoom.restriction_min_stay_thru,
              restriction_min_stay_thru_days: restrictionsForRoom.restriction_min_stay_thru ? dateToDays(action.startDate) : [],

            },
          }
        }
      }

      data = {
        ...data,
        periods: [
          {
            start: action.startDate,
            end: action.startDate,
          },
        ],
      }
      yield Effects.put({ type: PriceEditModalActions.SetData, payload: data })


    }
  }
}

const dateToDays = (date) => {
  const arr = []

  arr[1] = date.getDay() === 1
  arr[2] = date.getDay() === 2
  arr[3] = date.getDay() === 3
  arr[4] = date.getDay() === 4
  arr[5] = date.getDay() === 5
  arr[6] = date.getDay() === 6
  arr[7] = date.getDay() === 0

  return arr
}



export default function*() {
  yield Effects.throttle(
    1000,
    PriceConfigurationActions.RequestForConfiguration,
    loadConfiguration,
  )
  yield Effects.takeEvery(PriceGridAction.OpenRoomEditModal, loadPriceRoomSettings)
  yield Effects.takeEvery(PriceGridAction.OpenRoomEditModal, mixPanelEventRun)
  yield Effects.takeEvery(PriceGridAction.LoadRoomSettings, loadPriceRoomSettings)
  yield Effects.takeEvery(PriceEditModalActions.OpenPriceEditModal, loadPriceRoomSettings)
  yield Effects.takeEvery(PriceEditModalActions.OpenPriceEditModal, fetchData)
  yield Effects.takeEvery(PriceGridAction.LoadGlobalRoomSettings, fetchGlobalRoomSettings)
}
